module.exports = "/_next/static/images/022047e43dc88494157c0b4fad427c05-footer-fogafin-cucuta-4x.png";